import { DbUpdateInventoryAmount } from "../../../data/usecases/update-inventory-amount";
import { UpdateInventoryAmount } from "../../../domain/usecases/update-inventory-amount";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbUpdateInventory = (): UpdateInventoryAmount =>
  new DbUpdateInventoryAmount(
    makeApiUrl("/inventory/adjust"),
    makeAuthorizeHttpClientDecorator()
  );
